import EventBus from '@/components/mixins/event-bus-mixin'
import CONST from '@/globals/constants'

const LOCAL_STORAGE_UNSAVED_DATA = 'aryaUnsavedData'

export default {
  methods: {
    /**
      * Set unsaved data into localstorage
      * @param {Object} unsavedData
      */
    setUnsavedDataFlagIntoLocalstorage (unsavedData) {
      if (localStorage.getItem(LOCAL_STORAGE_UNSAVED_DATA) !== null) {
        this.removeUnsavedDataFlagInLocalStorage()
      }

      localStorage.setItem(LOCAL_STORAGE_UNSAVED_DATA, JSON.stringify(unsavedData))
    },
    /**
      * Get unsaved data from localstorage
      */
    getUnsavedDataFlagFromLocalstorage () {
      const unsavedData = localStorage.getItem(LOCAL_STORAGE_UNSAVED_DATA)

      if (unsavedData !== null) {
        return JSON.parse(unsavedData)
      }

      return null
    },
    removeUnsavedDataFlagInLocalStorage () {
      if (this.getUnsavedDataFlagFromLocalstorage() !== null) {
        localStorage.removeItem(LOCAL_STORAGE_UNSAVED_DATA)
      }
    },
    checkUnsavedData (params) {
      const currentRouteName = this.$route.name
      const pages = [
        'create-project-template',
        'edit-project-template',
        'create-template-set',
        'edit-project-audio',
        'player',
        'schedules',
        CONST.ROUTE_NAME_MEDIA,
        CONST.ROUTE_NAME_LED,
        CONST.ROUTE_NAME_VIDEOWALL,
        CONST.ROUTE_NAME_ALERT
      ]
      const showConfirmation = pages.includes(currentRouteName)

      if (this.getUnsavedDataFlagFromLocalstorage() !== null) {
        if (showConfirmation) {
          // Show Warning
          EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
            type: 'warning',
            title: this.$t('confirm.unsavedChanges'),
            alert: {
              message: this.$t('texts.youHaveUnsavedChanges')
            },
            confirmButtonText: this.$t('buttons.continueWithoutSaving'),
            callbacks: {
              eventOnClose: () => {
                if (params.cancelAction) params.cancelAction()
              },
              eventOKButtonClick: () => {
                this.removeUnsavedDataFlagInLocalStorage()
                params.nextAction()
              }
            }
          })
        } else {
          this.removeUnsavedDataFlagInLocalStorage()
          params.nextAction()
        }
      } else {
        params.nextAction()
      }
    }
  }
}
